import { render, staticRenderFns } from "./CheckInfoOneToOne.vue?vue&type=template&id=2bb7ab27&scoped=true&"
import script from "./CheckInfoOneToOne.vue?vue&type=script&lang=ts&"
export * from "./CheckInfoOneToOne.vue?vue&type=script&lang=ts&"
import style0 from "./CheckInfoOneToOne.vue?vue&type=style&index=0&id=2bb7ab27&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb7ab27",
  null
  
)

export default component.exports